import styled, { css } from 'styled-components';

export const Chip = styled.button<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  text-align: left;
  cursor: pointer;
  transition:
    background 200ms ease,
    border-color 200ms ease,
    color 200ms ease;

  /*
   * Selected state matches IntentCard: border colour changes + tick appears,
   * but the surface fill stays the same. Hover is the only state that tints
   * the surface.
   */
  ${({ $selected, theme: { colors, spacing, borderRadius, font } }) => css`
    ${font?.labelLarge}
    padding: ${spacing?.level4} ${spacing?.level5};
    border-radius: ${borderRadius?.large};
    border: 1px solid ${$selected ? colors?.primary : colors?.outlineVariant};
    background: ${colors?.surfaceContainerLow};
    color: ${colors?.onSurface};

    &:hover,
    &:focus-visible {
      border-color: ${$selected ? colors?.primary : colors?.outline};
      background: ${colors?.surfaceContainer};
      outline: none;
    }
  `}
`;

export const Label = styled.span`
  ${({ theme: { font } }) => css`
    ${font?.labelLarge}
    font-weight: 500;
  `}
`;

export const CheckIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  ${({ theme: { colors } }) => css`
    & > svg {
      width: 16px;
      height: 16px;
      fill: ${colors?.primary};
    }
  `}
`;
